import { render } from "./BaseExternalLink.vue?vue&type=template&id=7f70c8d8"
import script from "./BaseExternalLink.vue?vue&type=script&lang=js"
export * from "./BaseExternalLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__